module.exports = __webpack_public_path__ + "static/media/check-small.9444f07b.png";